module.exports = __webpack_public_path__ + "media/luxury-2026/nash-garden-exterior-960-4efcc1b4.jpg";